/**
 * Analytics gate.
 *
 * Nothing is reported to GTM / GA4, Surfside or react-ga unless the store has
 * seo turned on (`storeInfo.features.seoEnabled`). The flag is set once store
 * info arrives (see AppContainer) and every send goes through the helpers
 * below. Klaviyo is deliberately left outside this gate — it keeps running
 * regardless of the seo flag.
 */

let analyticsEnabled = false;

// Called from AppContainer as soon as /stores/info resolves
export const setAnalyticsEnabled = (value) => {
  analyticsEnabled = !!value;
};

export const isAnalyticsEnabled = () => analyticsEnabled;

// GTM / GA4
export const pushToDataLayer = (payload) => {
  if (!analyticsEnabled) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export default {
  setAnalyticsEnabled,
  isAnalyticsEnabled,
  pushToDataLayer,
};
